import { BusinessFunctionsSelectionBase } from '../../../../../components/business-functions';
import { GET_BUSINESS_FUNCTIONS } from '../../../../dataInputs/data-inputs/business-functions/queries';
import { UPDATE_SELECTED_BUSINESS_FUNCTIONS } from './queries';

const BusinessFunctionsTaggingSelection = () => {
  const briefText = `Select which business functions you’d like to add to the tagging workflow. If a business function is missing, you can add it by clicking the “Add Function” button.`;

  return (
    <BusinessFunctionsSelectionBase
      title="Enterprise Business Function Tagging"
      subtitle="Business Function Selection"
      brief={briefText}
      backPath="/cyber/enterprise-level/business-functions"
      fetchAllQuery={{
        query: GET_BUSINESS_FUNCTIONS,
        identifier: 'getBusinessFunctions',
        variables: {
          filter: {
            selected: false,
          },
        },
      }}
      fetchSelectedQuery={{
        query: GET_BUSINESS_FUNCTIONS,
        identifier: 'getBusinessFunctions',
        variables: {
          filter: {
            selected: true,
          },
        },
      }}
      updateMutation={{
        mutation: UPDATE_SELECTED_BUSINESS_FUNCTIONS,
      }}
      refetchQueries={[
        {
          query: GET_BUSINESS_FUNCTIONS,
          variables: {
            filter: {
              selected: false,
            },
          },
        },
      ]}
    />
  );
};

export default BusinessFunctionsTaggingSelection;
